<template>
  <div class="empresa-selector-overlay">
    <div class="empresa-selector-modal">
      <div class="modal-header">
        <h4 class="modal-title">
          <i class="bi bi-building me-2"></i>
          Seleccionar Empresa
        </h4>
      </div>
      
      <div class="modal-body">
        <p class="text-muted mb-3">
          Debe seleccionar una empresa para continuar:
        </p>
        
        <div class="empresa-list">
          <div 
            v-for="empresa in empresasActivas" 
            :key="empresa.EmpresaId"
            class="empresa-item"
            :class="{ 'selected': selectedEmpresa?.EmpresaId === empresa.EmpresaId }"
            @click="selectEmpresa(empresa)"
          >
            <div class="empresa-info">
              <h6 class="empresa-nombre">{{ empresa.Nombre }}</h6>
              <small class="empresa-codigo text-muted">Código: {{ empresa.EmpresaId }}</small>
            </div>
            <div class="empresa-check" v-if="selectedEmpresa?.EmpresaId === empresa.EmpresaId">
              <i class="bi bi-check-circle-fill text-success"></i>
            </div>
          </div>
        </div>
        
        <div v-if="empresasActivas.length === 0" class="text-center py-4">
          <i class="bi bi-exclamation-triangle text-warning fs-1"></i>
          <p class="mt-2">No hay empresas activas disponibles</p>
        </div>
      </div>
      
      <div class="modal-footer">
        <button 
          type="button" 
          class="btn btn-secondary me-2"
          @click="$emit('close')"
        >
          <i class="bi bi-x me-1"></i>
          Cancelar
        </button>
        <button 
          type="button" 
          class="btn btn-primary"
          :disabled="!selectedEmpresa || loading"
          @click="confirmarSeleccion"
        >
          <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
          <i v-else class="bi bi-check me-1"></i>
          {{ loading ? 'Procesando...' : 'Continuar' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import authService from '@/shared/services/auth';

export default {
  name: 'EmpresaSelector',
  data() {
    return {
      empresas: [],
      selectedEmpresa: null,
      loading: false
    };
  },
  computed: {
    empresasActivas() {
      return this.empresas.filter(empresa => empresa.EsActivo === true);
    }
  },
  created() {
    this.loadEmpresas();
  },
  methods: {
    loadEmpresas() {
      const userData = authService.getUserData();
      if (userData && userData._UsuarioMo && userData._UsuarioMo._EmpresaList) {
        this.empresas = userData._UsuarioMo._EmpresaList;
        console.log('Empresas cargadas:', this.empresas);
      } else {
        console.error('No se encontraron empresas en los datos del usuario');
        this.empresas = [];
      }
    },
    selectEmpresa(empresa) {
      this.selectedEmpresa = empresa;
    },
    async confirmarSeleccion() {
      if (this.selectedEmpresa && !this.loading) {
        this.loading = true;
        
        try {
          // Guardar la empresa seleccionada (ahora es async)
          const result = await authService.setSelectedEmpresa(this.selectedEmpresa);
          
          if (result.success) {
            console.log('Empresa seleccionada correctamente');
          } else {
            console.warn('Advertencia:', result.message);
          }
          
          // Emitir evento para notificar al componente padre
          this.$emit('empresa-selected', this.selectedEmpresa);
          
        } catch (error) {
          console.error('Error al seleccionar empresa:', error);
          // Aún así emitir el evento para que la aplicación continúe
          this.$emit('empresa-selected', this.selectedEmpresa);
        } finally {
          this.loading = false;
        }
      }
    }
  }
};
</script>

<style scoped>
.empresa-selector-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.empresa-selector-modal {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow: hidden;
}

.modal-header {
  padding: 1.5rem;
  border-bottom: 1px solid #dee2e6;
  background-color: #f8f9fa;
}

.modal-title {
  margin: 0;
  color: #495057;
}

.modal-body {
  padding: 1.5rem;
  max-height: 400px;
  overflow-y: auto;
}

.empresa-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.empresa-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border: 2px solid #e9ecef;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.empresa-item:hover {
  border-color: var(--primary-color);
  background-color: #f8f9fa;
}

.empresa-item.selected {
  border-color: #28a745;
  background-color: #d4edda;
}

.empresa-info {
  flex: 1;
}

.empresa-nombre {
  margin: 0 0 0.25rem 0;
  font-weight: 600;
  color: #495057;
}

.empresa-codigo {
  font-size: 0.875rem;
}

.empresa-check {
  font-size: 1.25rem;
}

.modal-footer {
  padding: 1rem 1.5rem;
  border-top: 1px solid #dee2e6;
  background-color: #f8f9fa;
  display: flex;
  justify-content: flex-end;
}
</style>